<template>
  <div class="map-container">
    <div id="map" class="map" style="width: 952px; height: 560px"></div>
    <div class="info-container">
      <div class="info">
        <div>
          <i class="iconfont icon-dizhi"></i>
          <span
            >深圳市宝安区福永镇<br />富桥第三工业区<br />华大威信实业B栋3楼</span
          >
        </div>
        <div>
          <i class="iconfont icon-24gl-phoneBubble"></i>
          <span><br /><br />0755-21000737</span>
        </div>
        <div>
          <el-image :src="code" class="code" alt="华运昌供应链" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Map',
  data() {
    return {
      code: require('@/assets/images/code/code.jpg')
    }
  },
  mounted() {
    this.initMap()
  },
  methods: {
    // 初始化地图
    initMap() {
      // 百度地图API功能
      const map = new BMap.Map('map') // 创建Map实例
      const point = new BMap.Point(113.80364, 22.675725)
      map.centerAndZoom(point, 13) // 初始化地图,设置中心点坐标和地图级别
      // 添加地图类型控件
      // map.addControl(new BMap.MapTypeControl({
      //   mapTypes: [
      //     BMAP_NORMAL_MAP,
      //     BMAP_HYBRID_MAP
      //   ] }))
      map.setCurrentCity('深圳') // 设置地图显示的城市 此项是必须设置的
      // map.enableScrollWheelZoom(true) // 开启鼠标滚轮缩放
      const marker = new BMap.Marker(point)
      marker.setLabel(this.setLabelStyle('华运昌供应链', -42, -52))
      map.addOverlay(marker)
      map.panTo(point)
    },

    // 设置地图label样式
    setLabelStyle(content, left, right) {
      // 左偏移 右偏移
      const offsetSize = new BMap.Size(left, right)
      const labelStyle = {
        color: '#000000',
        width: '100px',
        height: '40px',
        border: 'none',
        textAlign: 'center',
        lineHeight: '40px',
        borderRadius: '5px',
        borderBottom: '1px solid #cccccc'
      }
      const spanA = "<span class='angle'></span>"
      const label = new BMap.Label(content + spanA, {
        offset: offsetSize
      })
      label.setStyle(labelStyle)
      return label
    }
  }
}
</script>

<style scoped>
/*.angle{*/
/*  display: inline-block;*/
/*  width: 0px;*/
/*  height: 0px;*/
/*  position: absolute;*/
/*  bottom:-60px;*/
/*  border: 14px solid;*/
/*  left: 15px;*/
/*  bottom: -25px;*/
/*  opacity: 0.8;*/
/*  border-color: #333333 transparent transparent transparent;*/
/*}*/

.info-container {
  position: relative;
}

.map {
  position: relative;
  margin: auto;
  width: 100%;
}

.info {
  bottom: -70px;
  left: 50%;
  margin-left: -400px;
  position: absolute;
  background-color: #ffffff;
  width: 800px;
  height: 150px;
  border-radius: 5px;
  box-shadow: 10px 10px 5px #888888;
}

.info {
  display: flex;
  justify-content: space-between;
}

.info > div > i {
  font-size: 40px;
}

.code {
  display: block;
  width: 140px;
  height: 140px;
}
.info > div:nth-child(1) {
  border: none;
}

.info > div {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  margin: auto;
  border-left: 1px solid #f2f1f7;
}

.info > div > span {
  font-size: 12px;
}
</style>
